<template>
  <v-dialog
    v-model="show"
    @click:outside="close"
    width="500"
    @keydown.esc="close"
  >
    <v-card :loading="status == 'loading'">
      <v-toolbar :color="status == 'complete' ? 'green' : 'primary'" dark flat>
        <v-toolbar-title> Forgot password</v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon>
          <v-icon @click="close">fas fa-times</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pt-10">
        <div v-if="status != 'complete'">
          <p>Enter your email address, password will resend</p>

          <ValidationObserver ref="validator">
            <ValidationProvider ref="email" rules="required|email">
              <v-text-field
                slot-scope="{ errors, valid }"
                :error-messages="errors"
                :success="valid"
                v-model="user.email"
                :append-icon="'fas fa-envelope'"
                :type="'email'"
                name="input-10-1"
                label="Email"
                autocomplete="off"
                readonly
                onfocus="this.removeAttribute('readonly');"
                @change="setValidationMessage('')"
              ></v-text-field>
            </ValidationProvider>
          </ValidationObserver>
        </div>

        <v-alert color="green" dense text v-if="status == 'complete'">
          <v-row>
            <v-col cols="1">
              <v-icon color="green">fas fa-check-circle</v-icon>
            </v-col>

            <v-col>
              <p>{{ complete_message }}</p>
            </v-col>
          </v-row>
        </v-alert>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-row style="padding: 0; margin: 0">
          <v-col class="text-center" style="padding: 0; margin: 0">
            <v-btn
              v-if="status != 'complete'"
              color="primary"
              rounded
              elevation="0"
              @click="submit"
              :loading="status == 'loading'"
              >Resend
            </v-btn>

            <v-btn
              v-if="status == 'complete'"
              color="success"
              rounded
              elevation="0"
              @click="close"
              >Ok
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { mapState } from "vuex";

export default {
  props: ["show", "hide"],
  created() {},
  computed: {
    ...mapState({
      status: (state) => state.Authenticate.forgot_status,
    }),
  },
  data() {
    return {
      complete_message: "",
      user: {
        email: "",
      },
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  methods: {
    close() {
      this.user.email = "";
      this.$store.dispatch("Authenticate/reset_forgot_password");
      this.hide();
    },
    setValidationMessage(message) {
      this.validation_message = message;
    },
    async submit() {
      if (this.status == "complete") {
        close();
      } else {
        const self = this;
        const valid = await this.$refs.validator.validate();
        self.setValidationMessage("");
        if (valid) {
          self.$store
            .dispatch("Authenticate/forgot_password", self.user)
            .then(function (response) {
              self.complete_message = response.message;
            })
            .catch((response) => {
              // console.log(response);

              for (let i in response.errors) {
                try {
                  console.log(
                    "self.$refs." +
                      i +
                      ".setErrors('" +
                      response.errors[i] +
                      "');"
                  );
                  eval(
                    "self.$refs." +
                      i +
                      ".setErrors('" +
                      response.errors[i] +
                      "');"
                  );
                } catch (error) {
                  //
                }
              }
            });
        }
      }
    },
  },
};
</script>
